<script setup>

</script>

<template>
  <svg viewBox="0 0 19 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.6663 0.679688C4.52497 0.679688 0.343384 4.86388 0.343384 10.0052C0.343384 15.9825 8.29899 25.6922 8.63766 26.1016L9.6663 27.349L10.6949 26.1016C11.0336 25.6909 18.9892 15.9825 18.9892 10.0052C18.9892 4.86254 14.8076 0.679688 9.6663 0.679688ZM9.6663 3.34635C13.337 3.34635 16.3226 6.33454 16.3226 10.0052C16.3225 13.6119 12.1703 19.8149 9.6663 23.1016C7.1623 19.8176 3.01005 13.6172 3.01005 10.0052C3.01005 6.33454 5.99563 3.34635 9.6663 3.34635ZM9.6663 6.66667C7.82497 6.66667 6.33297 8.15867 6.33297 10C6.33297 11.8413 7.82497 13.3333 9.6663 13.3333C11.5076 13.3333 12.9996 11.8413 12.9996 10C12.9996 8.15867 11.5076 6.66667 9.6663 6.66667Z"
        fill="#CFD3DA"/>
  </svg>
</template>

<style scoped>
svg {
  width: 32px;
  min-width: 32px;
  height: 32px;
  display: block;
}
</style>